export default __webpack_public_path__ + "static/media/participants.df326ab6.png";